export default {
  data() {
    return {};
  },
  mounted() {
    // 隐藏菜单栏
    document.getElementById("menu").style.display = "none";
  },
  methods: {}
};